module.exports = __webpack_public_path__ + "img/man-sweeps.989bd8c8.png";